import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { UpdateCategoryForm } from '../../modules';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';

const CategoryUpdateView = () => {
    const { params: { id } } = useRouteMatch();
    return (
        <EditScreenLayout path={routePaths.categories}>
            <UpdateCategoryForm categoryId={id} />
        </EditScreenLayout>
    );
};


export default CategoryUpdateView;
